import Axios from "axios";

// Actions
import {
    CREATE_FREE_QUESTION,
    storeFreeQuestion,
    UPDATE_ADRESS,
    UPDATE_CITY,
    UPDATE_FIRSTNAME,
    UPDATE_LASTNAME,
    UPDATE_PHONE_NUMBER,
    UPDATE_USER,
    UPDATE_ZIP_CODE,
} from "../actions/FreeQuestionChatBot";
import {setRedirection} from "../actions/user";
import {setErrorApiMessage} from "../actions/apiFlag";
import {
    GET_QUESTIONS_ANSWERS,
    getQuestionsAnswers,
    setQuestionsAnswers,
    UPDATE_QUESTION,
    UPDATE_RESPONSE
} from "../actions/QuestionsAndAnswers";
// Utils
import {getApiBaseUrl} from "../utils/baseUrl";

// On définit par défaut un TimeOut Axios à 10 seconde au bout desquelles un code erreur "ECONNABORTED" est envoyé (code que l'on peut .catch dans une promesse)
// et qui permet donc de définir un message d'erreur en cas de non réponse de l'API
Axios.defaults.timeout = 1000000;

const freeQuestion = (store) => (next) => (action) => {
    switch (action.type) {
        case UPDATE_QUESTION : {

            const url = `${getApiBaseUrl()}/updateQuestion/`;

            const payload = {
                "session": {
                    "id": window.localStorage.id,
                    "idUser": window.localStorage.idUser,
                    "email": window.localStorage.email,
                },
                "idQuestion": action.id,
                "toUpdate": {
                    "state": action.state, // on accède à l'arguement passé en paramètre de la fonction updateQuestion(state, comment) grâce à action.monParamètre
                    "comment": action.comment // Le commentaire laissé par le user en cas de refus
                }
            };

            Axios.post(url, payload).then(() => {
                // Une fois l'update effectué, on met à jour les questions/réponses
                store.dispatch(getQuestionsAnswers());
            });
            // @TODO : peut-être introduire un .catch, à voir

            next(action);
            break;
        }
        case UPDATE_RESPONSE : {
            const state = store.getState();
            const {questionsAndAnswers} = state;
            // Les réponses avec un state égal à 0 correspondent aux réponses non lues
            // Cette requête est appelée au moment où le user rentre sur la page d'une question posée et permet de mettre à jour le statut de la réponse
            questionsAndAnswers.questionsAndAnswers.map((q) => {
                q.reponses.find((res) => {
                    // Si le statut de la réponse est sur 0, on veut update sur 1 pour signifier que la réponse a été vue par le user
                    if (res.state == 0) {
                        const url = `${getApiBaseUrl()}/updateReponse/`;

                        const payload = {
                            "session": {
                                "id": window.localStorage.id,
                                "idUser": window.localStorage.idUser,
                                "email": window.localStorage.email,
                            },
                            "idReponse": res.id,
                            "toUpdate": {
                                "state": 1
                            }
                        };
                        Axios.post(url, payload).then((res) => res);
                    }
                });

            });

            next(action);
            break;

        }
        case GET_QUESTIONS_ANSWERS : {

            const url = `${getApiBaseUrl()}/getQuestions/`;

            const payload = {
                "session": {
                    "id": window.localStorage.id,
                    "idUser": window.localStorage.idUser,
                    "email": window.localStorage.email,
                },
            };
            // Récupère les questions et les réponses
            Axios.post(url, payload).then((res) => {
                store.dispatch(setQuestionsAnswers(res.data.listQuestions.reverse())); // Inverse l'ordre du tableau pour afficher chronologiquement du plus ancien au plus récent
            });

            next(action);
            break;
        }
        case CREATE_FREE_QUESTION : {

            const url = `${getApiBaseUrl()}/createQuestion/`;

            const payload = {
                "session": {
                    "id": window.localStorage.id,
                    "idUser": window.localStorage.idUser,
                    "email": window.localStorage.email,
                },
                "question": {
                    "content": action.question
                }
            };
            // Sauvegarde la question posé par le user en BDD
            Axios.post(url, payload).then((res) => res);
            // Sauvegarde de la question dans l'état local
            store.dispatch(storeFreeQuestion(action.question));
            next(action);
            break;
        }
        case UPDATE_USER : {

            //====== Middleware permettant de mettre à jour en BDD les coorddonnées entrées par le user via le chat des questions gratuites

            const state = store.getState();
            const {planDemand} = state;
            const {userInfos} = planDemand;
            const url = `${getApiBaseUrl()}/updateUser/`;

            const payload = {
                "session": {
                    "id": window.localStorage.id,
                    "idUser": window.localStorage.idUser,
                    "email": window.localStorage.email,
                },
                // Les différents champs de la BDD à mettre à jour
                "toUpdate": {
                    "firstname": userInfos.firstname,
                    "name": userInfos.lastname,
                    "adress": userInfos.road,
                    "city": userInfos.city,
                    "cp": userInfos.cp
                }
            };

            Axios.post(url, payload)
                .catch((err) => {
                    if (err.response.status === 401) {
                        store.dispatch(setRedirection(true));
                    }
                    if (err.code === "ECONNABORTED") {
                        store.dispatch(setErrorApiMessage(true));
                        setTimeout(() => {
                            store.dispatch(setErrorApiMessage(false));
                        }, 5000);
                    }
                });
        }
            next(action);
            break;

        case UPDATE_FIRSTNAME : {
            const state = store.getState();
            const {planDemand} = state;
            const {userInfos} = planDemand;
            const url = `${getApiBaseUrl()}/updateUser/`;

            const payload = {
                "session": {
                    "id": window.localStorage.id,
                    "idUser": window.localStorage.idUser,
                    "email": window.localStorage.email,
                },
                "toUpdate": {
                    "firstname": userInfos.firstname, // Champ prénom mis à jour en BDD
                }
            };
            Axios.post(url, payload)
                .catch((err) => {
                    if (err.response.status === 401) {
                        store.dispatch(setRedirection(true));
                    }
                    if (err.code === "ECONNABORTED") {
                        store.dispatch(setErrorApiMessage(true));
                        setTimeout(() => {
                            store.dispatch(setErrorApiMessage(false));
                        }, 5000);
                    }

                });
        }
            next(action);
            break;
        case UPDATE_LASTNAME : {
            const state = store.getState();
            const {planDemand} = state;
            const {userInfos} = planDemand;
            const url = `${getApiBaseUrl()}/updateUser/`;

            const payload = {
                "session": {
                    "id": window.localStorage.id,
                    "idUser": window.localStorage.idUser,
                    "email": window.localStorage.email,
                },
                "toUpdate": {
                    "name": userInfos.lastname, // Champ nom mis à jour en BDD
                }
            };
            Axios.post(url, payload)
                .catch((err) => {
                    if (err.response.status === 401) {
                        store.dispatch(setRedirection(true));
                    }
                    if (err.code === "ECONNABORTED") {
                        store.dispatch(setErrorApiMessage(true));
                        setTimeout(() => {
                            store.dispatch(setErrorApiMessage(false));
                        }, 5000);
                    }
                });
        }
            next(action);
            break;
        case UPDATE_ADRESS : {
            const state = store.getState();
            const {planDemand} = state;
            const {userInfos} = planDemand;
            const url = `${getApiBaseUrl()}/updateUser/`;

            const payload = {
                "session": {
                    "id": window.localStorage.id,
                    "idUser": window.localStorage.idUser,
                    "email": window.localStorage.email,
                },
                "toUpdate": {
                    "adress": userInfos.route, // Champ adresse mis à jour en BDD
                }
            };
            Axios.post(url, payload)
                .catch((err) => {
                    if (err.response.status === 401) {
                        store.dispatch(setRedirection(true));
                    }
                    if (err.code === "ECONNABORTED") {
                        store.dispatch(setErrorApiMessage(true));
                        setTimeout(() => {
                            store.dispatch(setErrorApiMessage(false));
                        }, 5000);
                    }
                });
        }
            next(action);
            break;
        case UPDATE_CITY : {
            const state = store.getState();
            const {planDemand} = state;
            const {userInfos} = planDemand;
            const url = `${getApiBaseUrl()}/updateUser/`;

            const payload = {
                "session": {
                    "id": window.localStorage.id,
                    "idUser": window.localStorage.idUser,
                    "email": window.localStorage.email,
                },
                "toUpdate": {
                    "city": userInfos.city, // Champ ville mis à jour en BDD
                }
            };
            Axios.post(url, payload)
                .catch((err) => {
                    if (err.response.status === 401) {
                        store.dispatch(setRedirection(true));
                    }

                    if (err.code === "ECONNABORTED") {
                        store.dispatch(setErrorApiMessage(true));
                        setTimeout(() => {
                            store.dispatch(setErrorApiMessage(false));
                        }, 5000);
                    }

                });
        }
            next(action);
            break;
        case UPDATE_ZIP_CODE : {
            const state = store.getState();
            const {planDemand} = state;
            const {userInfos} = planDemand;
            const url = `${getApiBaseUrl()}/updateUser/`;

            const payload = {
                "session": {
                    "id": window.localStorage.id,
                    "idUser": window.localStorage.idUser,
                    "email": window.localStorage.email,
                },
                "toUpdate": {
                    "cp": userInfos.cp, // Champ cp (code postal) mis à jour en BDD
                }
            };
            Axios.post(url, payload)
                .catch((err) => {
                    if (err.response.status === 401) {
                        store.dispatch(setRedirection(true));
                    }
                    if (err.code === "ECONNABORTED") {
                        store.dispatch(setErrorApiMessage(true));
                        setTimeout(() => {
                            store.dispatch(setErrorApiMessage(false));
                        }, 5000);
                    }
                });
        }
            next(action);
            break;
        case UPDATE_PHONE_NUMBER : {
            const state = store.getState();
            const {planDemand} = state;
            const {userInfos} = planDemand;
            const url = `${getApiBaseUrl()}/updateUser/`;

            const payload = {
                "session": {
                    "id": window.localStorage.id,
                    "idUser": window.localStorage.idUser,
                    "email": window.localStorage.email,
                },
                "toUpdate": {
                    "tel": userInfos.tel, // Champ tel mis à jour en BDD
                }
            };
            Axios.post(url, payload)
                .catch((err) => {
                    if (err.response.status === 401) {
                        store.dispatch(setRedirection(true));
                    }
                    if (err.code === "ECONNABORTED") {
                        store.dispatch(setErrorApiMessage(true));
                        setTimeout(() => {
                            store.dispatch(setErrorApiMessage(false));
                        }, 5000);
                    }
                });
        }
            next(action);
            break;
        default:
            next(action);
    }
};

export default freeQuestion;